import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const FilterGroup = (props: Props) => {
  const { label, children, defaultCollapsed = true } = props;
  const [collapsed, setCollapsed] = useState(
    defaultCollapsed && Boolean(label)
  );

  return (
    <Wrapper>
      {label && (
        <Heading onClick={() => setCollapsed(!collapsed)}>
          <ChevronIcon
            size="xs"
            icon={!collapsed ? faChevronDown : faChevronRight}
          />
          {label}
        </Heading>
      )}
      {!collapsed && <CollapsedGroup>{children}</CollapsedGroup>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  // margin-bottom: 0.5rem;

  :last-child {
    margin-bottom: 0;
  }
`;

const Heading = styled.h3`
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border-top: 1px solid #e5e7eb;
  padding: 20px 20px;
  color: ${({ theme }) => theme?.colors?.text || "#1F2937"};
  :hover {
    background-color: ${({ theme }) => theme?.colors?.gray100 || "#F3F4F6"};
  }
`;

const ChevronIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

const CollapsedGroup = styled.div`
  padding: 0.5rem 0;
  background-color: ${({ theme }) => theme?.colors?.gray50 || "#F9FAFB"};
`;

type Props = {
  label?: string;
  children: React.ReactNode;
  defaultCollapsed?: boolean;
};

export default FilterGroup;
